import React, { useCallback, useEffect } from "react";
import { Image, Stack } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./GetAppAfterBonusPage.scss";
import { ROUTES } from "../../../utils/constants";
import useGetApp from "../../../hooks/useGetApp";
import {
  consumeStoredPostOnboardingRedirect,
  deleteStoredShowGetAppAfterInsuranceClaim,
} from "../../../utils/storage";
import useVendorDetection from "../../../hooks/useVendorDetection";
import DownloadAndroidAppModal from "../../../components/DownloadAndroidAppModal/DownloadAndroidAppModal";
import GetAppButton from "../../../components/GetAppButton/GetAppButton";
import OnboardingContainer from "../../../components/onboarding/OnboardingContainer/OnboardingContainer";
import useDisclosure from "../../../hooks/useDisclosure";
import useAnalytics from "../../../hooks/useAnalytics";
import { DownloadAppOptionProperty } from "../../../utils/analytics";
import ImageAppWinPreview from "../../../images/app-win-preview.png";

function GetAppAfterBonusPage() {
  const navigate = useNavigate();
  const { t } = useTranslation("common", { keyPrefix: "onboarding" });
  const { t: tCommon } = useTranslation("common");
  const { appExists } = useGetApp();
  const phoneVendor = useVendorDetection();
  const analytics = useAnalytics();
  const {
    isOpen: isAndroidAppDownloadOpen,
    onOpen: openDownloadAndroidApp,
    onClose: closeDownloadAndroidApp,
  } = useDisclosure();

  useEffect(() => {
    deleteStoredShowGetAppAfterInsuranceClaim();
  }, []);

  const handleProceed = useCallback(() => {
    navigate(consumeStoredPostOnboardingRedirect(ROUTES.ROOT.DASHBOARD));
  }, [navigate]);

  const onCloseAndroidDownloadModal = useCallback(() => {
    handleProceed();
    closeDownloadAndroidApp();
  }, [closeDownloadAndroidApp, handleProceed]);

  const onGetAppBtnClick = useCallback(() => {
    if (phoneVendor) handleProceed();
  }, [handleProceed, phoneVendor]);

  const handleMaybeLater = () => {
    analytics.sendDownloadAppOptionsEvent(DownloadAppOptionProperty.SKIP);
    handleProceed();
  };

  return (
    <OnboardingContainer className="GetAppAfterBonusPage">
      <Stack className="get-app-after-bonus-content">
        <div className="copy">
          <h1 className="heading">
            {t("hyper_works_best_with_the_mobile_app")}
          </h1>
          <p className="subheading">
            {t(
              "play_1v1_and_multiplayer_games_join_tournaments_and_win_real_cash",
            )}
          </p>
        </div>
        <div className="visual-block">
          <div className="hero-with-cta">
            <Image
              src={ImageAppWinPreview}
              alt=""
              width={238}
              height={407}
              className="win-preview"
            />
            <div className="get-app-button-wrap">
              <GetAppButton
                label={appExists ? tCommon("use_app") : tCommon("download_app")}
                openDownloadAndroidApp={openDownloadAndroidApp}
                onBtnClick={onGetAppBtnClick}
              />
            </div>
          </div>
          <button
            type="button"
            className="maybe-later-button"
            onClick={handleMaybeLater}
          >
            {appExists ? tCommon("continue_on_web") : t("maybe_later")}
          </button>
        </div>
      </Stack>
      <DownloadAndroidAppModal
        isOpen={isAndroidAppDownloadOpen}
        onClose={onCloseAndroidDownloadModal}
      />
    </OnboardingContainer>
  );
}

export default GetAppAfterBonusPage;
